export default __webpack_public_path__ + "static/media/seller-agreement.3b9b24f7.pdf";